/**
 * Marketing header for the landing page (#103, D103.2). Distinct from the in-game
 * {@link ../AppHeader} (which carries a role badge + live-connection dot on the game
 * surfaces): this is the front-door nav that folds in the old home-hub links. The brand
 * (mark + wordmark) is a home link; the nav reaches the remaining surfaces — Leaderboard,
 * Presentation, Profile — with "Host"/"Join" living in the hero as the primary CTAs
 * (FR-15.1: the front door optimizes for getting into a game). The brand text is read
 * from {@link BRAND_NAME} (FR-9.11) — never hard-coded. Sign-in reuses the existing
 * app-owned {@link SignIn} affordance.
 */

import { Link } from 'react-router-dom';
import { BRAND_NAME } from '../brand';
import { SignIn } from '../SignIn';

export function LandingHeader(): React.JSX.Element {
  return (
    <header className="landing-nav" data-testid="landing-header">
      <Link to="/" className="landing-brand" data-testid="landing-brand">
        <img
          src="/peril-mark.svg"
          className="landing-brand__mark"
          alt=""
          aria-hidden="true"
        />
        <span className="landing-brand__word">{BRAND_NAME}</span>
      </Link>
      <nav className="landing-nav__links" aria-label="Primary">
        <a
          href="/#how"
          className="landing-nav__link landing-hide-sm"
          data-testid="link-how"
        >
          How it works
        </a>
        <Link
          to="/faq"
          className="landing-nav__link landing-hide-sm"
          data-testid="link-faq"
        >
          FAQ
        </Link>
        <Link
          to="/leaderboard"
          className="landing-nav__link landing-hide-sm"
          data-testid="link-leaderboard"
        >
          Leaderboard
        </Link>
        <Link
          to="/presentation"
          className="landing-nav__link landing-hide-sm"
          data-testid="link-presentation"
        >
          Presentation
        </Link>
        <Link
          to="/profile"
          className="landing-nav__link landing-hide-sm"
          data-testid="link-profile"
        >
          Profile
        </Link>
        <SignIn />
      </nav>
    </header>
  );
}
